import React from 'react';
import { Box, Typography } from '@mui/material';
import { THEME_COLOR } from '../../../theme/formStyles';

export const TICKET_STAGES = [
    { key: 'open', label: 'Open' },
    { key: 'assigned', label: 'Engineer assigned' },
    { key: 'scheduled', label: 'Visit scheduled' },
    { key: 'resolved', label: 'Resolved' },
];
export const stageLabel = (stage) => TICKET_STAGES.find(s => s.key === stage)?.label || 'Open';

export const PRIORITY_STYLE = {
    Low: { color: '#475569', bgcolor: '#f1f5f9' },
    Medium: { color: '#1a6894', bgcolor: '#f1f8fc' },
    High: { color: '#c2410c', bgcolor: '#fff1e6' },
    Urgent: { color: '#c62828', bgcolor: '#ffebee' },
};

// Open → Engineer assigned → Visit scheduled → Resolved
export default function TicketStageTracker({ stage, compact = false }) {
    const idx = Math.max(0, TICKET_STAGES.findIndex(s => s.key === stage));
    return (
        <Box sx={{ display: 'flex', alignItems: 'flex-start', mt: compact ? 0.75 : 1.25 }}>
            {TICKET_STAGES.map((s, i) => {
                const done = i <= idx;
                return (
                    <Box key={s.key} sx={{ flex: 1, position: 'relative', textAlign: 'center' }}>
                        {i > 0 && <Box sx={{ position: 'absolute', top: 8, right: '50%', width: '100%', height: 2, bgcolor: i <= idx ? THEME_COLOR : '#e5e9ee' }} />}
                        <Box sx={{ position: 'relative', mx: 'auto', width: 18, height: 18, borderRadius: '50%', display: 'grid', placeItems: 'center', fontSize: 10, color: '#fff',
                            bgcolor: done ? THEME_COLOR : '#fff', border: `2px solid ${done ? THEME_COLOR : '#e5e9ee'}`, boxShadow: i === idx && stage !== 'resolved' ? '0 0 0 3px #e6f4f2' : 'none' }}>
                            {done ? '✓' : ''}
                        </Box>
                        {!compact && <Typography sx={{ fontSize: '10.5px', mt: 0.5, color: i === idx ? THEME_COLOR : '#6b7785', fontWeight: i === idx ? 700 : 400, lineHeight: 1.2 }}>{s.label}</Typography>}
                    </Box>
                );
            })}
        </Box>
    );
}
